<template>
  <div class="progress-ring">
    <div class="progress">{{ recommendation.confidence }}<sup>%</sup></div>

    <svg :height="radius * 2" :width="radius * 2">
      <circle class="under"
              stroke="#e5e4e9"
              :stroke-dasharray="circumference + ' ' + circumference"
              :stroke-width="stroke"
              fill="transparent"
              :r="normalizedRadius"
              :cx="radius"
              :cy="radius"/>

      <circle class="over"
              stroke="#333438"
              :stroke-dasharray="circumference + ' ' + circumference"
              :style="{strokeDashoffset: strokeDashoffset}"
              :stroke-width="stroke"
              fill="transparent"
              :r="normalizedRadius"
              :cx="radius"
              :cy="radius"/>
    </svg>

    <div class="size-recommendation">{{ recommendation.size }}</div>
  </div>
</template>

<script>
export default {
  name: "ProgressRing",

  props: {
    recommendation: Object,
  },

  data() {
    const radius = 75;
    const stroke = 4;

    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    return {
      radius,
      stroke,
      normalizedRadius,
      circumference,
    };
  },

  computed: {
    strokeDashoffset() {
      return this.circumference - this.recommendation.confidence / 100 * this.circumference;
    },
  },
};
</script>
